import Swiper from 'swiper/bundle';

export default function initSliders() {
    const swiper = new Swiper('.project-slider', {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 40,
        breakpoints: {
            640: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 30
            },
            1024: {
                slidesPerView: 3,
            }
        },
      
        // Navigation arrows
        navigation: {
          nextEl: '.swiper-btn-next',
          prevEl: '.swiper-btn-prev',
        },
      
      });  
      
const logo_swiper = new Swiper(".logo_slider", {
    slidesPerView: 9,
    slidesPerGroup: 1,
    spaceBetween: 30,
    loop: true,
    speed: 800,
    centeredSlides: true,
    autoplay: {
        delay: 2500,
        disableOnInteraction: false, 
    },
    breakpoints: {
        320: {
            slidesPerView: 3,
            centeredSlides: false,
        },
        768: {
            slidesPerView: 5,
            centeredSlides: false,
        },
        1024: {
            slidesPerView: 6,
            centeredSlides: true,
        },
        1280: {
            slidesPerView: 9,
            centeredSlides: true,
        }
    }
});

}


